<div class="loading" *ngIf="loader"></div>
<form>
    <div class="row no-gutters content_top_margin">
        <div class="col-12">
            <fieldset aria-required="true" class="control" aria-labelledby="lblCoApplicantScreen">
                <legend role="radiogroup" id="lblCoApplicantScreen"
                    class="legend_display sectionHeading_one bot_spa_aft_sect_heading"> {{
                    'digitalSwitch.additionalMortgageOption' | translate }}</legend>
                <div class="row no-gutters bot_spa_aft_sect_heading">
                    <div class="col-12 d-md-inline-flex">
                        <div>
                            <label
                                [class]="borderColorY ? 'selectBorder d-flex radio_button_border  field_lable_bot_margin_unset' :'nonSelectBorder d-flex radio_button_border  field_lable_bot_margin_unset' ">
                                <div class="nobtn"
                                    [ngClass]="(borderColorY && selectionY != null) ? 'cst-rd-check':'cst-rd'">
                                    <input tabindex="0" id="yesRadio" id="yes" [attr.aria-checked]="selectionY"
                                        type="radio" name="alpha" [checked]="selectionY" (click)="buttonDisplay('yes')"
                                        [attr.aria-label]="'digitalSwitch.additionalMortgageOption' | translate " />
                                    <div class="border-on-focus"></div>
                                </div>
                                <span class="ml-2">
                                    {{ 'co-applicant-selection.yes' | translate }}
                                </span>
                            </label>
                        </div>

                        <div class=" space_between_field">
                            <label
                                [class]="borderColorN ? 'selectBorder d-flex radio_button_border  field_lable_bot_margin_unset' : ' nonSelectBorder d-flex radio_button_border  field_lable_bot_margin_unset' ">
                                <div class="nobtn"
                                    [ngClass]="(!borderColorY && selectionY != null) ? 'cst-rd-check':'cst-rd'">
                                    <input tabindex="0" id="no" style="width:0px !important;"
                                        [attr.aria-checked]="selectionN" class="radioPosition" type="radio" name="alpha"
                                        [checked]="selectionN" (click)="buttonDisplay('no')" />
                                    <div class="border-on-focus"></div>
                                </div>
                                <span class="ml-2">
                                    {{ 'co-applicant-selection.no' | translate }}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row no-gutters">
                    <legend role="radiogroup" id="lblCoApplicantScreen"
                        class="legend_display sectionHeading_one bot_spa_aft_sect_heading">
                        {{'digitalSwitch.additionalMortgageInterestRate' | translate }}</legend>
                </div>
                <div class="row no-gutters">
                    <div class="col-md-5 col-lg-3 col-12">
                        <div class="income-wrapper">
                            <input type="text" (input)="validate($event)" class="wdd-fl border-cls"
                                [formControl]="interest" (focus)="isSelected=true" (blur)="isSelected=false"
                                [ngClass]="displayValidation?'validationBorder':isSelected?'selectBorder':'nonSelectBorder'"
                                [attr.aria-label]="'digitalSwitch.additionalMortgageInterestRate' | translate">
                            <div class="percent-input">
                                <span>%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
                    <div class="col-12 d-flex d-md-block flex-column-reverse">
                        <cancel-button></cancel-button>
                        <button type="button" class="common_btn saveNextBtn_features space_between_button"
                            (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</form>